module.exports = __webpack_public_path__ + "img/space-introduce-6-en.9c0b9d2e.svg";